<template>
  <div>
    <a-modal v-model:visible="visible" title="新增预约" @ok="appointment" okText="新建" cancelText="取消" :afterClose="closeModal" width="40vw">
      <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

        <div class="form">
          <a-input placeholder="客户名称" v-model:value="inputs.name" />

          <a-button type="primary" shape="circle" style="margin-right: 20px;" @click="SearchCustomer">
            <template #icon>
              <SearchOutlined />
            </template>
          </a-button>

          <a-button type="primary" @click="visible2=true">新增客户</a-button>
        </div>

        <a-table class="ant-table-striped" :columns="columns" :data-source="data" :row-selection="rowSelection" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" :pagination="pagination" bordered>

        </a-table>
        <div v-if="selectedRowKeys.length > 0" class="selectedRow" style="margin-top: 20px;">
          <!-- <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-form-item label="日期">
              <a-date-picker v-model:value="inputs.date" valueFormat="YYYY-MM-DD" placeholder="日期" style="width:300px" />
            </a-form-item>
            <a-form-item label="开始时间">
              <a-time-picker format="HH:mm" v-model:value="inputs.period[0]" placeholder="" />
              <a-time-range-picker v-model="inputs.period" format="HH:mm" />
            </a-form-item>
            <a-form-item label="结束时间">
              <a-time-picker format="HH:mm" v-model:value="inputs.period[1]" placeholder="" />
            </a-form-item>

          </a-form> -->
        </div>
        <div class="btnBox">
          <!-- <a-button type="primary" @click="appointment">预约</a-button> -->
        </div>
      </a-form>

    </a-modal>
  </div>
  <addCustomer v-model="visible2" @selectCustomer="selectCustomer" />

</template>

<script>
import { reactive } from "vue";
import { Add } from "/src/api/disease.js";
import { pinyin } from 'pinyin-pro';
import { SearchCustomer, AddAppointment } from "/src/api/todayConsultation.js";
import addCustomer from '/src/components/todayConsultation/addCustomer.vue';
import {
  SearchOutlined,
} from "@ant-design/icons-vue";
export default {
  components: {
    SearchOutlined,
    addCustomer
  },
  data() {
    return {
      visible: this.modelValue,
      visible2: false,
      inputs: {
        date: new Date().toLocaleDateString(),
      },
      columns: [
        {
          title: "姓名",
          key: "name",
          dataIndex: "name",
          width: "20%",
          slots: {
            customRender: "name"
          }
        },
        {
          title: "年龄",
          key: "age",
          dataIndex: "age",
          width: "20%",
          slots: {
            customRender: "age"
          }
        },
        {
          title: "性别",
          key: "gender",
          dataIndex: "gender",
          width: "20%",
          slots: {
            customRender: "gender"
          }
        },
        {
          title: "手机",
          key: "mobile",
          dataIndex: "mobile",
          ellipsis: true,
          width: "25%",
          slots: {
            customRender: "mobile"
          },
        },
      ],
      data: [
      ],
      selectedRows: {},
      labelCol: {
        span: 6,
      },
      pagination: { pageSize: 10 },
      wrapperCol: {
        span: 14,
      },

      selectedRowKeys: [], // 选择行的key数组


    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
  },
  activated() {

  },
  computed: {
    rowSelection() {
      return {
        type: "radio",
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`SelectedRowKeys: ${selectedRowKeys}`, 'SelectedRows: ', selectedRows);
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows
          // this.data = selectedRows
          // this.pagination = false
          console.log(selectedRowKeys);

        },
      };
    }
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    async SearchCustomer() {
      this.selectedRowKeys = []
      // this.pagination = { pageSize: 10 };
      let res = await SearchCustomer({ name: this.inputs.name })
      if (res.errCode == 0) {
        this.data = res.data.records
      }
    },
    async appointment() {
      console.log(this.selectedRows.id);

      let res = await AddAppointment({ customerId: this.selectedRows[0].id, appointingName: "智慧中医" })
      console.log("AddAppointment",res);
      
      if (res.errCode == 0) {
        this.$message.success("预约成功", function () { });
        this.$emit("reSearch")
        this.$emit("openRecordModal",res.data)
        this.closeModal()
      }
    },
    resetForm() {
      this.inputs.name = ""
    },
    Detail(record) {
      this.$router.push({ name: "customerDetail", query: { id: record.id } });
    },
    async onEdit(key) {
    },
    async onDelete(id) {
      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }

    },

    selectCustomer(value) {

      this.data = [value]
      this.selectedRows = value
      this.selectedRowKeys = [0]
      console.log(value);
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },


  },
  watch: {
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}

.form {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.form .ant-input {
  width: 200px;
  margin-right: 30px;
}
.btnBox {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.btnBox .ant-btn {
  margin-right: 10px;
}
</style>
